// removed by extract-text-webpack-plugin
module.exports = {"quotes":"quotes","quotes__wrap":"quotes__wrap","quotes__inner":"quotes__inner","quotes__person":"quotes__person","quotes__info":"quotes__info","quotes__descr":"quotes__descr","quotes__img":"quotes__img","quotes__title":"quotes__title","quotes__subtitle":"quotes__subtitle","quotes_no-img":"quotes_no-img"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_quotes.scss
// module id = 95
// module chunks = 0